import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { PlusPaywallSuspense } from "scmp-app/components/plus/plus-paywall-suspense";
import type { featuredOpinionBlockQuery$key } from "scmp-app/queries/__generated__/featuredOpinionBlockQuery.graphql";

import { FeaturedOpinionBlockContainer } from "./featured-opinion-block-container";
import { Container, PlaceHolderContainer, StyledImagePlaceholder } from "./styles";

export type Props = {
  className?: string;
  reference: featuredOpinionBlockQuery$key;
};

export const FeaturedOpinionBlock: FunctionComponent<Props> = ({ className, reference }) => {
  const content = useFragment(
    graphql`
      fragment featuredOpinionBlockQuery on Query
      @argumentDefinitions(excludeQueueName: { type: "String!" }) {
        highlightQueue: queue(filter: { name: $excludeQueueName }) {
          items(first: 6) {
            edges {
              node {
                ... on Content {
                  entityId
                }
              }
            }
          }
        }
      }
    `,
    reference,
  );

  return (
    <Container className={className}>
      <PlusPaywallSuspense
        fallback={
          <PlaceHolderContainer>
            <StyledImagePlaceholder />
          </PlaceHolderContainer>
        }
      >
        <FeaturedOpinionBlockContainer
          excludeEntityIds={[
            ...(content.highlightQueue?.items?.edges?.map?.(edge => edge?.node?.entityId ?? "") ??
              []),
          ]}
          queueName="scmp_plus_featured_opinion"
        />
      </PlusPaywallSuspense>
    </Container>
  );
};

FeaturedOpinionBlock.displayName = "FeaturedOpinionBlock";
